/* console.log('Infinite Scroll JS Loaded'); */

let isLoading = false;
let observer = null;

async function loadMoreProducts() {

    if (isLoading) return;

    const button = document.querySelector('#load-more');

    if (!button) {
        /* console.log('No more pages'); */
        return;
    }

    const nextUrl = button.dataset.url;

    if (!nextUrl) {
        /* console.log('No next URL'); */
        return;
    }

    isLoading = true;

    button.disabled = true;
    button.innerHTML = 'Loading...';

    try {

        const response = await fetch(nextUrl);

        if (!response.ok) {
            throw new Error('Failed to load products');
        }

        const html = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const currentGrid = document.querySelector('#product-grid');
        const newGrid = doc.querySelector('#product-grid');

        if (currentGrid && newGrid) {
            currentGrid.insertAdjacentHTML(
                'beforeend',
                newGrid.innerHTML
            );
        }

        const newButton = doc.querySelector('#load-more');

        if (newButton) {

            button.dataset.url = newButton.dataset.url;
            button.disabled = false;
            button.innerHTML = 'Load More';

            setupObserver();

        } else {

            button.parentElement.remove();

            if (observer) {
                observer.disconnect();
            }

            /* console.log('All products loaded'); */
        }

    } catch (error) {

        console.error(error);

        button.disabled = false;
        button.innerHTML = 'Load More';
    }

    isLoading = false;
}

function setupObserver() {

    const button = document.querySelector('#load-more');

    if (!button) return;

    if (observer) {
        observer.disconnect();
    }

    observer = new IntersectionObserver(
        (entries) => {

            entries.forEach(entry => {

                if (entry.isIntersecting && !isLoading) {

                    /* console.log('Loading next page'); */

                    loadMoreProducts();
                }

            });

        },
        {
            root: null,
            rootMargin: '400px',
            threshold: 0
        }
    );

    observer.observe(button);
}

document.addEventListener('DOMContentLoaded', () => {

    setupObserver();

});

/* Optional Manual Click Support */
document.addEventListener('click', function(e) {

    const button = e.target.closest('#load-more');

    if (!button) return;

    e.preventDefault();

    loadMoreProducts();

});